import { IStoreGroupInitialState, TStoreGroupPayloads } from '../types';

/**
 * Will update store group state
 *
 * @param {IStoreGroupInitialState} state
 * @param {*} payload
 */
export const updateStoreGroupState = (
    state: IStoreGroupInitialState,
    payload: TStoreGroupPayloads
) => ({
    ...state,
    loading: false,
    error: null,
    ...payload,
});
